export default {
  methods: {
    zoomIn() {
      const currWidth = this.$refs.image.clientWidth
      const maxWidth = 10000
      if (currWidth < maxWidth) {
        this.$refs.image.style.width = `${currWidth + 200}px`
      }
    },

    zoomOut() {
      const currWidth = this.$refs.image.clientWidth
      const minWidth = 100
      if (currWidth > minWidth) {
        this.$refs.image.style.width = `${currWidth - 200}px`
      }
    },
  },

  mounted() {
    this.$refs.image.style.width = `${this.$el.clientWidth}px`
  },
}
